"use strict";

exports.__esModule = true;
exports.ReportTagContext = void 0;
var _Utils = require("../../../Utils");
var _ReportTagController = require("./ReportTagController");
/**
 * Provides a rest api to consumers.
 * @component
 */
var ReportTagContext = exports.ReportTagContext = (0, _Utils.createEnhancedContext)({
  propName: "reportTags",
  defaultController: _ReportTagController.ReportTagController
});